import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import Modal, { ModalBody, ModalFooter, ModalFooterChild, ModalHeader } from "../ui/Modal";
import Button from "../ui/Button";

const SignUpWarningModel = ({ open, setOpen, handleClose, handleLogin }) => {
  // if (!open) return null; // Only render modal if open is true

  return (
    <>
      <Modal
        isOpen={open}
        setIsOpen={setOpen}
        isAnimation={true}
        isCentered={true}
        isScrollable={true}
        isStaticBackdrop={"rounded-3xl"}
        size={"sm"}
        bg={"white"}
      >
        <ModalHeader className="text-black dark:text-white">Hold On! Sign In First</ModalHeader>
        <ModalBody>
          <div className="mt-2 text-black dark:text-white">
            You need to log in to access this feature. Please sign in or sign up to continue.
          </div>
        </ModalBody>

        <ModalFooter className="mt-[20px]">
          <ModalFooterChild></ModalFooterChild>
          <ModalFooterChild>
            <Button
              onClick={handleLogin}
              className="cursor-pointer flex items-center !text-white text-[16px] !bg-[#4caf50]"
            >
              Sign In
            </Button>
            <Button
              onClick={handleClose}
              className="cursor-pointer flex items-center !text-black text-[16px] !bg-[#FEBA06]"
            >
              Not Now
            </Button>
          </ModalFooterChild>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SignUpWarningModel;
